import { Component, OnInit, Input } from '@angular/core';
import { TaskService } from 'src/app/core/service/task.service';
import { Channel } from 'src/app/channel/model/channel';
import { EventService } from 'src/app/core/service/event.service';
import { EventListService } from 'src/app/core/service/grid-data/grid-data-event.service';
import { ChannelService } from 'src/app/core/service/channel.service';

@Component({
  standalone: false,
  selector: 'app-task-detail-related-to',
  templateUrl: './task-detail-related-to.component.html',
  styleUrls: ['./task-detail-related-to.component.scss']
})
export class TaskDetailRelatedToComponent implements OnInit
{

  @Input() public taskId: string;

  public relatedTo: any;
  public channel: Channel;
  public task: any;
  public event: any;
  public loading = true;
  public showClinicalEvents = false;
  public eventTypeIcon = '';

  constructor(
    private eventListService: EventListService,
    private taskService: TaskService,
    private channelService: ChannelService,
    private eventService: EventService,
  ) { }

  public ngOnInit(): void
  {
    this.taskService.getTaskRelatedTo(this.taskId).subscribe({
      next: (data) =>
      {
        this.relatedTo = data;
        if (this.relatedTo.type === 'channel')
        {
          this.channelService.getChannelByProcessInstance(this.relatedTo.id).subscribe({
            next: (channelData) =>
            {
              this.channel = channelData;
              this.loading = false;
            }
          });
        }
        else if (this.relatedTo.type === 'task')
        {
          this.taskService.getTask(this.relatedTo.id, true).subscribe({
            next: (dataTask) =>
            {
              this.task = dataTask;
              this.loading = false;
            }
          });
        }
        else if (this.relatedTo.type === 'event')
        {
          this.eventService.getEvent(this.relatedTo.id, this.taskId).subscribe({
            next: (dataEvent) =>
            {
              this.event = dataEvent;
              this.event.eventTypeText = this.eventListService.getEventTypeText(this.event.eventType);
              this.event.encounterTypeText = this.eventListService.getEncounterTypeText(this.event.encounterType);
              this.event.atTime = new Date(dataEvent.eventDateTime).toLocaleTimeString();
              this.event.eventTypeIcon = this.eventListService.getEventTypeIcon(this.event.eventType);

              this.loading = false;
            }
          });
        }
      }
    });
  }

  public showEventDetails(e: Event): void
  {
    e.preventDefault();
    this.showClinicalEvents = true;
  }

  public closeEventDetails(): void
  {
    this.showClinicalEvents = false;
  }

  public showRelatedTo(): boolean
  {
    return this.showRelatedToChannel() || this.showRelatedToEvent() || this.showRelatedToTask();
  }

  public showRelatedToChannel(): boolean
  {
    return (this.relatedTo !== undefined && this.relatedTo.type === 'channel' && this.channel !== undefined && this.channel !== null);
  }

  public showRelatedToEvent(): boolean
  {
    return (this.relatedTo !== undefined && this.relatedTo.type === 'event');
  }

  public showRelatedToTask(): boolean
  {
    return (this.relatedTo !== undefined && this.relatedTo.type === 'task');
  }
}
